import React from "react";
import { useSelector } from "react-redux";

const Loader = () => {

    const { isShowLoader, isShowHomePageLoader } = useSelector(state => state.loader);
    
    if (!isShowLoader && !isShowHomePageLoader) {
        return false;
    }

    return <div className="page-loader">
        <div id="preloader">
            <div className="loader" />
        </div>
    </div>
}

export default Loader